const getNextClicableEl = (nodes, activeIndex, direction) => {
    const beforeActive = nodes.slice(0, activeIndex);
    const afterActive = nodes.slice(activeIndex + 1);
    const processedNodes = direction === 'forward'
        ? [...afterActive, ...beforeActive]
        : [...beforeActive.reverse(), ...afterActive.reverse()];
    const nextEl = processedNodes.find((el) => el.nodeName === 'A' || el.nodeName === 'BUTTON');
    return nextEl && nextEl;
};
export default getNextClicableEl;
//# sourceMappingURL=getNextClickableEl.js.map